// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-control.overflow-x[data-v-6579e0ed]{height:55px;padding:12px;display:flex;align-items:center}", ""]);
// Exports
module.exports = exports;
